import React from 'react';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Link } from 'react-router-dom';
import { UsersIcon, BriefcaseIcon, CheckIcon, StarIcon, CheckCircleIcon, ArrowRightIcon } from 'lucide-react';
const Teams = () => {
  // Mock teams data
  const teams = [{
    id: 1,
    name: 'WebTech Solutions',
    logo: 'https://via.placeholder.com/100?text=WTS',
    description: 'Full-stack development team specializing in Laravel and Vue.js applications.',
    members: 8,
    location: 'San Francisco, CA',
    projects: 45,
    services: ['Web Development', 'API Integration', 'E-commerce']
  }, {
    id: 2,
    name: 'DevOps Ninjas',
    logo: 'https://via.placeholder.com/100?text=DN',
    description: 'Expert team focused on DevOps, CI/CD pipelines, and cloud infrastructure for Laravel apps.',
    members: 5,
    location: 'London, UK',
    projects: 32,
    services: ['DevOps', 'AWS', 'Docker', 'CI/CD']
  }, {
    id: 3,
    name: 'UX Wizards',
    logo: 'https://via.placeholder.com/100?text=UXW',
    description: 'Design and development team creating beautiful, user-friendly Laravel applications.',
    members: 12,
    location: 'Berlin, Germany',
    projects: 78,
    services: ['UI/UX Design', 'Frontend Development', 'User Testing']
  }, {
    id: 4,
    name: 'Data Masters',
    logo: 'https://via.placeholder.com/100?text=DM',
    description: 'Specialized in data-heavy Laravel applications, analytics, and reporting solutions.',
    members: 7,
    location: 'Toronto, Canada',
    projects: 29,
    services: ['Data Analytics', 'Reporting Systems', 'Database Optimization']
  }];
  return <div className="bg-[#0F1115] min-h-screen text-gray-300 relative" data-id="element-1888">
      {/* Global Grain Texture */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none z-50 bg-grain mix-blend-overlay" data-id="element-1889"></div>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-[#0F1115] via-[#1a1d24] to-[#111827] text-white overflow-hidden" data-id="element-1890">
        {/* Subtle grain texture */}
        <div className="absolute inset-0 opacity-[0.015] bg-grain" data-id="element-1891"></div>

        {/* Animated background elements */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-1892">
          <div className="absolute top-20 left-10 w-72 h-72 bg-gradient-to-br from-[#d73b3e]/10 to-transparent rounded-full blur-3xl" data-id="element-1893" />
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-gradient-to-br from-orange-500/10 to-transparent rounded-full blur-3xl" data-id="element-1894" />
        </div>

        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28 relative z-10" data-id="element-1895">
          <div className="max-w-4xl mx-auto text-center" data-id="element-1896">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full border border-white/20 mb-6" data-id="element-1897">
              <UsersIcon className="w-4 h-4 text-[#d73b3e]" data-id="element-1898" />
              <span className="text-sm font-medium" data-id="element-1899">
                {teams.length}+ Expert Teams
              </span>
            </div>

            <h1 className="font-display text-5xl lg:text-6xl font-bold mb-6 leading-tight tracking-tight" data-id="element-1900">
              Find expert{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#d73b3e] to-orange-500" data-id="element-1901">
                dev teams
              </span>
            </h1>

            <p className="text-xl lg:text-2xl text-gray-300 mb-10 leading-relaxed" data-id="element-1902">
              Connect with agencies and certified development teams for your
              projects
            </p>

            <Link to="#teams" className="inline-block px-8 py-4 bg-[#d73b3e] text-white rounded-full font-semibold text-lg hover:bg-[#c02f32] transition-all duration-300 shadow-lg hover:shadow-xl" data-id="element-1903">
              Browse Teams
            </Link>

            {/* Trust indicators */}
            <div className="flex flex-wrap justify-center gap-8 text-sm text-gray-400 mt-8" data-id="element-1904">
              <div className="flex items-center gap-2" data-id="element-1905">
                <CheckCircleIcon className="h-5 w-5 text-green-400" data-id="element-1906" />
                <span data-id="element-1907">Verified development teams</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-1908">
                <CheckCircleIcon className="h-5 w-5 text-green-400" data-id="element-1909" />
                <span data-id="element-1910">200+ successful projects</span>
              </div>
            </div>
          </div>
        </div>

        {/* Curved divider */}
        <div className="absolute bottom-0 left-0 right-0" data-id="element-1911">
          <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full" data-id="element-1912">
            <path d="M0 120L60 105C120 90 240 60 360 45C480 30 600 30 720 37.5C840 45 960 60 1080 67.5C1200 75 1320 75 1380 75L1440 75V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0Z" fill="#0F1115" data-id="element-1913" />
          </svg>
        </div>
      </section>

      {/* Teams List */}
      <section className="py-16 relative z-10" id="teams" data-id="element-1914">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1915">
          <div className="grid md:grid-cols-2 gap-8" data-id="element-1916">
            {teams.map(team => <div key={team.id} className="bg-[#1a1d24] rounded-2xl border border-gray-800 p-6 hover:border-gray-700 transition-all duration-300" data-id="element-1917">
                <div className="flex items-start" data-id="element-1918">
                  <div className="w-16 h-16 bg-white/5 rounded-xl flex items-center justify-center overflow-hidden border border-gray-800" data-id="element-1919">
                    <img src={team.logo} alt={team.name} className="w-full h-full object-cover" data-id="element-1920" />
                  </div>
                  <div className="ml-4 flex-1" data-id="element-1921">
                    <h3 className="text-xl font-semibold text-white" data-id="element-1922">
                      {team.name}
                    </h3>
                    <div className="flex items-center text-sm text-gray-400 mt-1" data-id="element-1923">
                      <UsersIcon className="h-4 w-4 mr-1.5 text-gray-500" data-id="element-1924" />
                      {team.members} team members
                      <span className="mx-2" data-id="element-1925">•</span>
                      {team.location}
                    </div>
                  </div>
                </div>

                <p className="mt-4 text-gray-400 leading-relaxed" data-id="element-1926">
                  {team.description}
                </p>

                <div className="mt-4" data-id="element-1927">
                  <div className="text-sm font-medium text-gray-300 mb-2" data-id="element-1928">
                    Services:
                  </div>
                  <div className="flex flex-wrap gap-2" data-id="element-1929">
                    {team.services.map((service, index) => <span key={index} className="bg-white/5 text-gray-300 text-xs px-3 py-1.5 rounded-full border border-gray-800" data-id="element-1930">
                        {service}
                      </span>)}
                  </div>
                </div>

                <div className="mt-6 pt-4 border-t border-gray-800 flex items-center justify-between" data-id="element-1931">
                  <div className="flex items-center text-sm text-gray-400" data-id="element-1932">
                    <BriefcaseIcon className="h-4 w-4 mr-1.5 text-gray-500" data-id="element-1933" />
                    {team.projects} projects completed
                  </div>
                  <button className="px-4 py-2 bg-white/5 text-white rounded-full text-sm font-medium hover:bg-white/10 transition-all duration-300 border border-gray-800" data-id="element-1934">
                    View Profile
                  </button>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Why Choose a Team Section */}
      <section className="py-20 bg-gradient-to-br from-[#1a1d24] to-[#0F1115] relative z-10" data-id="element-1935">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1936">
          <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-1937">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 leading-tight" data-id="element-1938">
              Why choose a{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#d73b3e] to-orange-500" data-id="element-1939">
                development team?
              </span>
            </h2>
            <p className="text-lg text-gray-400" data-id="element-1940">
              Development teams offer comprehensive solutions for complex
              projects
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-1941">
            <div className="bg-[#1a1d24] p-8 rounded-2xl shadow-lg border border-gray-800 hover:border-gray-700 transition-colors" data-id="element-1942">
              <div className="w-14 h-14 bg-gradient-to-br from-[#d73b3e]/10 to-orange-500/10 rounded-2xl flex items-center justify-center mb-6 border border-white/5" data-id="element-1943">
                <UsersIcon className="h-7 w-7 text-[#d73b3e]" data-id="element-1944" />
              </div>
              <h3 className="text-xl font-semibold mb-3 text-white" data-id="element-1945">
                Diverse Expertise
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-1946">
                Access a range of specialists including designers, developers,
                and QA engineers all working together.
              </p>
            </div>

            <div className="bg-[#1a1d24] p-8 rounded-2xl shadow-lg border border-gray-800 hover:border-gray-700 transition-colors" data-id="element-1947">
              <div className="w-14 h-14 bg-gradient-to-br from-[#d73b3e]/10 to-orange-500/10 rounded-2xl flex items-center justify-center mb-6 border border-white/5" data-id="element-1948">
                <CheckIcon className="h-7 w-7 text-[#d73b3e]" data-id="element-1949" />
              </div>
              <h3 className="text-xl font-semibold mb-3 text-white" data-id="element-1950">
                Proven Processes
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-1951">
                Benefit from established workflows, code reviews, and quality
                assurance procedures.
              </p>
            </div>

            <div className="bg-[#1a1d24] p-8 rounded-2xl shadow-lg border border-gray-800 hover:border-gray-700 transition-colors" data-id="element-1952">
              <div className="w-14 h-14 bg-gradient-to-br from-[#d73b3e]/10 to-orange-500/10 rounded-2xl flex items-center justify-center mb-6 border border-white/5" data-id="element-1953">
                <StarIcon className="h-7 w-7 text-[#d73b3e]" data-id="element-1954" />
              </div>
              <h3 className="text-xl font-semibold mb-3 text-white" data-id="element-1955">
                End-to-End Service
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-1956">
                Get comprehensive project management from planning and design
                through development and launch.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-gray-900 to-black text-white border-t border-gray-800 relative z-10" data-id="element-1957">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1958">
          <div className="max-w-3xl mx-auto text-center" data-id="element-1959">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 leading-tight" data-id="element-1960">
              Need a team for your{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#d73b3e] to-orange-500" data-id="element-1961">
                project?
              </span>
            </h2>
            <p className="text-xl text-gray-300 mb-10" data-id="element-1962">
              Post your project requirements and get matched with the right team
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-1963">
              <Link to="/post-job" className="px-8 py-4 bg-[#d73b3e] text-white rounded-full font-semibold text-lg hover:bg-[#c02f32] transition-all duration-300 shadow-lg hover:shadow-xl" data-id="element-1964">
                Post a Project
              </Link>
              <Link to="/developers" className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white rounded-full font-semibold text-lg hover:bg-white/20 transition-all duration-300 border-2 border-white/20" data-id="element-1965">
                Browse Developers
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>;
};
export default Teams;